import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProgress } from "../model/progress";
import { getUsersProgress as getUsersProgramProgress } from "../api/progress";

interface ProgressState {
  currentUsersProgramProgress: UserProgress[] | null
}

const initialState: ProgressState = {
  currentUsersProgramProgress: [],
};

const sortAlphabetical = <T extends {[key: string]: any }>(items: T[], ascending: boolean, field: string): T[] => {
  const copy = items.slice();

  copy.sort((a, b) => {
    let aValue = a[field]?.toLowerCase() ?? ""
    let bValue = b[field]?.toLowerCase() ?? ""
    
    return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
  });

  return copy
};

const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    sortCurrentUsersProgramProgress: (state, action: PayloadAction<{ ascending: boolean, field: string}>) => {
      if (state.currentUsersProgramProgress == null) {
        return
      }

      state.currentUsersProgramProgress = sortAlphabetical(state.currentUsersProgramProgress, action.payload.ascending, action.payload.field);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersProgramProgressAsync.fulfilled, (state: ProgressState, action: PayloadAction<UserProgress[]>) => {
        state.currentUsersProgramProgress = action.payload;
      })
      .addCase(getUsersProgramProgressAsync.rejected, (state: ProgressState, action) => {
        console.error(action.error.message);
      })
  }
});

export const getUsersProgramProgressAsync = createAsyncThunk('program/getUsersProgramProgressAsync', async ({ accessToken, programId }: { accessToken: string, programId: string}) => {
    const response = await getUsersProgramProgress(accessToken, programId);
    return response;
  }
);

export const { sortCurrentUsersProgramProgress } = progressSlice.actions;
export default progressSlice.reducer;